import React from "react";
import { Image } from "react-bootstrap";

const PrintInfoStatus = () => {
  const userData = sessionStorage.getItem('user');
  const userObj = userData ? JSON.parse(userData) : {};
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const logoUrl = `${baseUrl}/uploads/get-image/${userObj.logo}`;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
      <Image src={logoUrl} alt="School Logo" style={{ maxWidth: "60px", height: "auto" }} fluid rounded />
      <h4 style={{ margin: 0, fontSize: "1.1rem" }}>
        {userObj.school_name} ({userObj.branch})
      </h4>
    </div>
  );
};

const PrintableReceipt = ({ form, receiptData, studentFeeSchedule = [] }) => {
  const totalBalance = studentFeeSchedule.reduce(
    (sum, item) => sum + (parseFloat(item.balance_amount_to_be_paid) || 0),
    0
  );

  return (
    <div
      style={{
        height: "50%",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
        fontSize: "8px",
      }}
    >
      <PrintInfoStatus />

      <div className="printable-content">
        <h2 style={{ textAlign: "center", fontSize: "18px", marginBottom: "10px" }}>FEE RECEIPT</h2>

        <table width="100%" cellPadding="6" style={{ borderCollapse: "collapse", marginBottom: "15px" }}>
          <tbody>
            <tr>
              <td>Date</td>
              <td>{form.reciept_date}</td>
              <td>Admission No</td>
              <td>{form.admission_number}</td>
              <td>Receipt No</td>
              <td>{form.receipt_no}</td>
            </tr>
            <tr>
              <td>Student Name</td>
              <td colSpan="3">{form.student_name}</td>
              <td>Class & Sec</td>
              <td>{form.section_name}</td>
            </tr>
            <tr>
              <td>Father Name</td>
              <td colSpan="3">{form.father_name}</td>
              <td>Contact No</td>
              <td>{form.contact_no}</td>
            </tr>
            <tr>
              <td>Mode of Payment</td>
              <td colSpan="2">{form.mode}</td>
              <td>Remarks</td>
              <td colSpan="2">{form.remarks}</td>
            </tr>
          </tbody>
        </table>

        <h3 style={{ fontSize: "16px", marginBottom: "8px" }}>Fee Particulars</h3>
        <table width="100%" border="1" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Fee Item</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {receiptData.amountDetails.map((item, index) => (
              <tr key={index}>
                <td>{item.fees_item}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Total Paid</strong></td>
              <td><strong>{receiptData.grandTotal}</strong></td>
            </tr>
          </tfoot>
        </table>

        {/* New Section: Fee Schedule Balance Details */}
        {studentFeeSchedule.length > 0 && (
          <>
            <h3 style={{ fontSize: "16px", marginTop: "12px", marginBottom: "8px" }}>Fee Schedule Summary</h3>
            <table width="100%" border="1" style={{ borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>Schedule</th>
                  <th>Scheduled Amount</th>
                  <th>Paid Amount</th>
                  <th>Balance</th>
                  <th>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {studentFeeSchedule.map((item, index) => (
                  <tr key={index}>
                    <td>{item.schedule_name}</td>
                    <td>{item.scheduled_amount}</td>
                    <td>{item.amount_paid}</td>
                    <td>{item.balance_amount_to_be_paid}</td>
                    <td>{item.due_date}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                <td colSpan="3" style={{textAlign:"right"}}><strong>Total Outstanding</strong></td>
                  <td colSpan="2"><strong>{totalBalance.toFixed(2)}</strong></td>
                </tr>
              </tfoot>
            </table>
          </>
        )}
      </div>

      <br/><br/>
      <div><br/><br/><br/><br/></div>
    </div>
  );
};

export default PrintableReceipt;
